<template>
  <!-- Estado de reembolso leído en vivo desde Stripe. Cubre pagos anteriores y
       refunds hechos fuera del panel, que no tienen registro en la base. -->
  <PaymentDetailField v-if="hasPermission" label="Refund status (Stripe)">
    <span v-if="loading" class="text-gray-500">Checking Stripe...</span>
    <span v-else-if="error" class="text-gray-500">
      Could not load from Stripe: {{ error }}
      <button class="underline ml-1 no-print" @click="load">Retry</button>
    </span>
    <template v-else-if="payment">
      <span
        class="refund-status-pill"
        :class="
          status === 'NOT REFUNDED'
            ? 'refund-status-pill--none'
            : 'refund-status-pill--refunded'
        "
        >{{ status }}</span
      >
      <div v-if="payment.amountRefunded > 0" class="refund-status-detail">
        {{ payment.amountRefunded | currencyFormatted(true) }} of
        {{ payment.amountCaptured | currencyFormatted(true) }} refunded
        <span v-if="payment.refunds.length > 0">
          ({{ payment.refunds.length }}
          {{ payment.refunds.length === 1 ? "refund" : "refunds"
          }}<template v-if="outsideAdminCount > 0"
            >, {{ outsideAdminCount }} made outside the admin</template
          >)
        </span>
      </div>
      <div
        v-if="payment.linkedOrders && payment.linkedOrders.length > 1"
        class="refund-status-detail"
      >
        The charge covers orders
        {{ payment.linkedOrders.map(o => "#" + o.orderNumber).join(", ") }}
      </div>
    </template>
  </PaymentDetailField>
</template>
<script>
import { getStripePayment } from "@/api/store/StripeRefundsService.js";
import PaymentDetailField from "@/components/payments/PaymentDetailField.vue";

export default {
  name: "StripeLiveRefundStatus",
  components: { PaymentDetailField },
  props: {
    paymentIntentId: { type: String, required: true },
    // Contexto para validar el vínculo en el backend: orden o cobro POS
    orderNumber: { type: Number, required: false, default: null },
    posTransactionId: { type: [Number, String], required: false, default: null }
  },
  data() {
    return {
      loading: false,
      error: null,
      payment: null
    };
  },
  computed: {
    hasPermission() {
      return this.$store.getters["auth/userHasPermission"](
        "can_refund_payment"
      );
    },
    status() {
      if (!this.payment || this.payment.amountRefunded <= 0) {
        return "NOT REFUNDED";
      }
      return this.payment.refundableCents <= 0
        ? "REFUNDED"
        : "PARTIALLY REFUNDED";
    },
    // Refunds sin admin en la metadata: hechos en el dashboard de Stripe
    outsideAdminCount() {
      return this.payment.refunds.filter(r => !r.adminEmail).length;
    }
  },
  mounted() {
    if (this.hasPermission) this.load();
  },
  methods: {
    async load() {
      this.loading = true;
      this.error = null;
      try {
        this.payment = await getStripePayment(
          this.$store.getters["auth/currentToken"],
          {
            orderNumber: this.orderNumber,
            posTransactionId: this.posTransactionId
          },
          this.paymentIntentId
        );
      } catch (err) {
        this.error = err.response?.data?.error ?? err.message;
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
<style scoped>
.refund-status-pill {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 9999px;
  font-size: 12px;
  font-weight: 700;
}
.refund-status-pill--none {
  background: #f3f4f6;
  color: #374151;
}
.refund-status-pill--refunded {
  background: #fee2e2;
  color: #991b1b;
}
.refund-status-detail {
  margin-top: 4px;
  font-size: 12.5px;
  color: #6b7280;
}
</style>
